angular.module('directives.dashboard').directive('wgtSaleTop', ['DashboardApiService',
    function (DashboardApiService) {
        return {
            templateUrl: 'directives/dashboard/widgets/wgtSaleTop/wgtSaleTop.tpl.html',
            link: function ($scope) {
                $scope.isLoaded = false;
                $scope.hasError = false;

                $scope.loadWidget = function () {
                    DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                        .then(function (response) {
                            if (response.data === '') {
                                //No data, leaving
                                return;
                            }
                            $scope.widgetData = response.data;
                            $scope.isLoaded = true;
                        }, function (response) {
                            $scope.hasError = true;
                        });
                };
                $scope.loadWidget();
            }
        };
    }
]);
